import React, { useEffect, useMemo, useRef, useState } from "react"
import moment from "moment"
import i18n from "../../services/i18n"
import "./board.less"

// tog'a #3457/#3460 (2026-10-04): «Табло склада» — omborda katta monitor uchun. Faqat ko'rish: ishdagi qatorlar (Новый/Собирается/Готово),
// eng uzoq kutgan tepada; katta yozuv; 30+ daqiqa qizil; yangi zakaz — ovoz + «НОВЫЙ»; sig'masa sahifalar 15 soniyada almashadi.
// Ichki sahifa (kirgan xodim) va login'siz monitor havolasi (/board/<token>) shu komponentni ishlatadi.

const t = (k: string, d: string) => i18n.t(k, d)
const pad = (n: number) => String(n).padStart(2, "0")
const hms = (min: number) => { const s = Math.max(0, Math.floor(min * 60)); return `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}` }
const ST: Record<string, [string, string]> = {
  new: ["b-s1", "🟡 " + t("wdStNew", "Новый")],
  picking: ["b-s2", "🔵 " + t("wdStPicking", "Собирается")],
  ready: ["b-s3", "🟣 " + t("wdStReady", "Готово")],
}
// qator/sarlavha balandligi board.less dagi clamp(…vw…) bilan BIR XIL formula — sahifaga nechta qator sig'ishi shundan
const cl = (min: number, v: number, max: number) => Math.min(max, Math.max(min, v))
const FOOT_H = 58

// tog'a #4104: `hideBatch` — hamkor tizimida (ichki sahifa) partiya ko'rsatilmaydi, ustunda faqat joy. Login'siz monitor (/board/<token>)
// bu prop'ni bermaydi — u avvalgidek qoladi (kirgan foydalanuvchi yo'q, tizimni bilib bo'lmaydi).
export default function BoardView({ data, title, sub, error, onClose, hideBatch }: { data: any; title?: string; sub?: string; error?: string | null; onClose?: () => void; hideBatch?: boolean }) {
  const [, tick] = useState(0)
  useEffect(() => { const id = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(id) }, [])
  const [vp, setVp] = useState(() => ({ w: window.innerWidth, h: window.innerHeight }))
  useEffect(() => { const on = () => setVp({ w: window.innerWidth, h: window.innerHeight }); window.addEventListener("resize", on); return () => window.removeEventListener("resize", on) }, [])
  const rowH = cl(70, vp.w * 0.0615, 118), headH = cl(64, vp.w * 0.054, 104) + cl(36, vp.w * 0.029, 56)
  const perPage = Math.max(3, Math.floor((vp.h - headH - FOOT_H) / rowH))

  const lines: any[] = useMemo(() => data?.lines || [], [data])
  const skew = useMemo(() => (data?.now ? Date.now() - moment(data.now).valueOf() : 0), [data?.now])
  const minutesOf = (r: any) => (Date.now() - skew - moment(r.at).valueOf()) / 60000
  const yellow = Number(data?.yellowMin || 15), red = Number(data?.redMin || 30)
  const colorOf = (r: any, m: number) => (r.status === "ready" ? "ready" : m >= red ? "red" : m >= yellow ? "yellow" : "green")

  // sahifalash: 15 soniyada keyingi sahifa
  const pages = Math.max(1, Math.ceil(lines.length / perPage))
  const [page, setPage] = useState(0)
  const [nextIn, setNextIn] = useState(15)
  useEffect(() => {
    const id = setInterval(() => setNextIn((s) => { if (s <= 1) { setPage((p) => (p + 1) % Math.max(1, Math.ceil((lines.length || 1) / perPage))); return 15 } return s - 1 }), 1000)
    return () => clearInterval(id)
  }, [lines.length, perPage])
  const pg = page % pages
  const shown = lines.slice(pg * perPage, pg * perPage + perPage)

  // yangi qator — ovoz (brauzer ovozni faqat bir marta bosilgandan keyin ruxsat beradi)
  const [sound, setSound] = useState(false)
  const seen = useRef<Set<number> | null>(null)
  const audio = useRef<AudioContext | null>(null)
  useEffect(() => {
    const ids = new Set<number>(lines.map((r) => Number(r.id)))
    if (seen.current) {
      const fresh = lines.some((r) => !seen.current!.has(Number(r.id)) && r.status === "new")
      if (fresh && sound && audio.current) {
        const ctx = audio.current, now = ctx.currentTime
        ;[0, 0.25].forEach((dt, i) => { const o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.value = i ? 1175 : 880; g.gain.setValueAtTime(0.0001, now + dt); g.gain.exponentialRampToValueAtTime(0.4, now + dt + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, now + dt + 0.22); o.connect(g).connect(ctx.destination); o.start(now + dt); o.stop(now + dt + 0.24) })
      }
    }
    seen.current = ids
  }, [lines, sound])
  const enableSound = () => { try { audio.current = audio.current || new (window.AudioContext || (window as any).webkitAudioContext)(); audio.current.resume(); setSound(true) } catch { } }

  const c = data?.counts || {}
  return (
    <div className="b-wrap" data-testid="board">
      <div className="b-top">
        <h1>📦 {title || t("wbTitle", "ОКНО СКЛАДА")}</h1>
        {sub && <span className="b-wh">{sub}</span>}
        <div className="b-cnt">
          <span className="b-c b-c1">🟡 {t("wbNew", "Новые")} <b>{c.new ?? 0}</b></span>
          <span className="b-c b-c2">🔵 {t("wbPicking", "Собираются")} <b>{c.picking ?? 0}</b></span>
          <span className="b-c b-c3">🟣 {t("wdStReady", "Готово")} <b>{c.ready ?? 0}</b></span>
          {(c.late ?? 0) > 0 && <span className="b-c b-c4">⏰ {t("wbLate", "Ждут 30+")} <b>{c.late}</b></span>}
        </div>
        <span className="b-clock">{moment().format("HH:mm")}</span>
        {onClose && <button className="b-close" onClick={onClose} title="✕" data-testid="board-close">✕</button>}
      </div>
      {error ? (
        <div className="b-empty">⚠️ {error}</div>
      ) : !data ? (
        <div className="b-empty">…</div>
      ) : lines.length === 0 ? (
        <div className="b-empty">✅ {t("wbAllDone", "Все заказы собраны — новых нет")}</div>
      ) : (
        <>
          <div className="b-hd"><span>{t("date", "Дата")}</span><span>{t("article", "Артикул")}</span><span>{t("wdClient", "Клиент")}</span><span>{hideBatch ? t("stColumn", "Место") : t("wdBatchPlace", "Партия · место")}</span><span className="r">{t("wbQty", "Кол-во")}</span><span>{t("status", "Статус")}</span><span className="c">⏱ {t("wdTimer", "Таймер")}</span></div>
          <div className="b-rows">
            {shown.map((r) => { const m = minutesOf(r); const col = colorOf(r, m); return (
              <div key={r.id} className={"b-row" + (col === "red" ? " late" : "") + (r.fresh ? " fresh" : "")} data-testid="board-row">
                <span className="b-dt">{moment(r.at).format("HH:mm")}<small>{moment(r.at).format("DD.MM")}</small></span>
                <span className="b-art">{r.article || "—"}<small>{r.product}</small></span>
                <span className="b-cl"><span className="b-cn">{r.client}{r.fresh && <span className="b-badge">{t("wbFresh", "НОВЫЙ")}</span>}</span><small>{r.document}</small></span>
                <span className="b-pt">{hideBatch ? (r.place ? <b>📍 {r.place}</b> : "—") : <>{r.batch || "—"}{r.place && <b>📍 {r.place}</b>}</>}</span>
                <span className="b-q">{Number(r.qty).toLocaleString("ru-RU", { maximumFractionDigits: 2 })}</span>
                <span><span className={"b-st " + (ST[r.status]?.[0] || "")}>{ST[r.status]?.[1] || r.status}</span>{r.takenBy && r.status !== "new" && <small className="b-by">{r.takenBy}</small>}</span>
                <span className={"b-tm b-" + col}>{hms(m)}</span>
              </div>) })}
          </div>
        </>
      )}
      <div className="b-foot">
        {!sound ? <button className="b-snd" onClick={enableSound} data-testid="board-sound">🔊 {t("wbSoundOn", "Включить звук новых заказов")}</button> : <span>🔔 {t("wbSoundIs", "Звук новых заказов включён")}</span>}
        <span>{t("wbRefresh", "Обновление каждые 10 сек")}</span>
        {pages > 1 && <span className="b-pg">{t("wbPage", "Страница")} {pg + 1} / {pages} · {t("wbNext", "следующая через")} {nextIn} {t("secShort", "с")}</span>}
      </div>
    </div>
  )
}
